<template>
  <v-dialog v-model="dialog" max-width="1000px" scrollable>
    <template v-slot:activator="{ on }">
      <span v-on="on" class="cursor-pointer">
        <slot></slot>
      </span>
    </template>
    <dialog-card title="Preview" :isSubmit="false" @close="dialog = false">
      <please-wait v-if="loading" />
      <template v-else>
        <template v-if="isPdf">
          <iframe
            :src="`${url}#zoom=65`"
            width="100%"
            height="600px"
            style="border: none"
          ></iframe>
        </template>
        <div v-else>
          <img
            :src="url"
            width="100%"
            height="600"
            contain
            class="mx-auto"
            style="object-fit: contain"
          />
        </div>
      </template>
    </dialog-card>
  </v-dialog>
</template>

<script>
import DialogCard from "@/components/ui/DialogCard.vue";
import axios from "axios";
import PleaseWait from "@/components/ui/PleaseWait.vue";

export default {
  components: { DialogCard, PleaseWait },
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      contentType: null,
    };
  },
  computed: {
    isPdf() {
      return this.contentType == "application/pdf";
    },
  },
  watch: {
    dialog(val) {
      if (val && this.contentType == null) {
        this.fetchContentType();
      }
    },
  },
  methods: {
    getContentTypeFromUrl(url) {
      const filename = url.split("?")[0].split("/").pop();
      const extension = filename.split(".").pop().toLowerCase();

      const mimeTypes = {
        pdf: "application/pdf",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        webp: "image/webp",
        bmp: "image/bmp",
        svg: "image/svg+xml",
        ico: "image/x-icon",
        tif: "image/tiff",
        tiff: "image/tiff",
        avif: "image/avif",
      };
      console.log("Content-type", filename, mimeTypes[extension]);
      return mimeTypes[extension];
    },
    async fetchContentType() {
      try {
        this.loading = true;
        if (this.getContentTypeFromUrl(this.url || "")) {
          this.contentType = this.getContentTypeFromUrl(this.url || "");
          this.loading = false;
          return;
        }
        let res = await axios.get(this.url);
        this.contentType = res.headers["content-type"];
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style></style>
